<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Wrapper -->
<div class="flex flex-auto w-full min-w-0">
	<div class="flex flex-col w-full">
		<div
			class="relative flex flex-0 items-center w-full h-16 sm:h-20 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
			<ng-container *ngIf="!isScreenSmall">
				<!-- Logo -->
				<div class="flex items-center mx-2 lg:mr-8">
					<div class="md:hidden lg:flex">
						<img class="w-24" src="assets/common/images/logo/voh-logo.png">
					</div>
					<img class="flex lg:hidden w-4" src="assets/common/images/logo/voh-logo.png">
				</div>
				<!-- Components -->
				<div>
					<search class="search-component" [appearance]="'bar'"></search>
				</div>
				<!-- Horizontal navigation -->
				<div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
					<fuse-horizontal-navigation class="mr-2" [name]="'mainNavigation'"
						[navigation]="menuItems"></fuse-horizontal-navigation>

<!--
					<div *ngIf="isLoggedIn">
						<messages></messages>
					</div>
-->
					<div *ngIf="isLoggedIn">
						<notifications></notifications>
					</div>
<!--
					<button *ngIf="isLoggedIn" class="lg:hidden" mat-icon-button (click)="quickChat.toggle()">
						<mat-icon [svgIcon]="'heroicons_outline:chat-alt-2'"></mat-icon>
					</button>
-->
					<user></user>
				</div>
			</ng-container>
			<!-- Navigation toggle button -->
			<ng-container *ngIf="isScreenSmall">
				<button mat-icon-button (click)="toggleNavigation('mainNavigation')">
					<mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
				</button>
			</ng-container>
		</div>

		<!-- Content -->
		<div class="flex flex-0 flex-auto w-full">
			<!-- Navigation -->
			<fuse-vertical-navigation class="sideMenu dark bg-gray-900 print:hidden" [appearance]="'compact'"
				[mode]="isScreenSmall ? 'over' : 'side'" [name]="'sideNavigation'" [navigation]="sideMenuItems"
				[opened]="!isScreenSmall">
				<!-- Navigation header hook -->
				<ng-container fuseVerticalNavigationContentHeader>
					<!-- Logo -->
					<div class="flex items-center justify-center h-4">

					</div>
				</ng-container>
			</fuse-vertical-navigation>
			<!-- Header -->

			<!-- *ngIf="true" hack is required here for router-outlet to work correctly.
                Otherwise, layout changes won't be registered and the view won't be updated! -->
			<div class="flex flex-col flex-auto w-full">
				<app-header></app-header>
				<router-outlet *ngIf="true"></router-outlet>
				<app-footer></app-footer>
			</div>
			<!--
			<quick-chat *ngIf="isLoggedIn" #quickChat="quickChat"></quick-chat>
-->
		</div>
	</div>
</div>
